export default __webpack_public_path__ + "static/media/icon-linkedin.7e77834a.svg";